import React from 'react';
import styled from 'styled-components';

import userRole from 'config/userRole';
import useAuth from 'hooks/useAuth';

import PageHeader from './PageHeader';
import PageSearch from './PageSearch';
import NotificationsDropdown from './notifications/NotificationsDropdown';

import { Space } from './layout';
import { useFeatureToggleItem } from './FeatureToggle';
import featureToggles from 'config/featureToggles';
import ChatDropdown from './chat/ChatDropdown';

const StyledPageHeader = styled(PageHeader)`
  & .ant-page-header-heading {
    min-height: 48px;
    max-height: 48px;
    position: relative;

    & .ant-page-header-heading-left {
      flex: 1;
    }

    & .ant-page-header-heading-extra {
      position: absolute;
      right: 0;
      // top: 50%;
      // transform: translateY(-60%);
    }
  }
`;

const mainPageHeaderActions = [
  {
    name: 'chat',
    component: ChatDropdown,
  },
  {
    name: 'search',
    component: PageSearch,
  },
  {
    name: 'notifications-untagged',
    component: NotificationsDropdown,
    defaultProps: {
      title: "Individual Code Alerts",
      iconName: "user-x",
      showAllLink: "/alerts?type=missing_tags",
      showOnly: ['missing_tags']
    },
  },
  {
    name: 'notifications',
    component: NotificationsDropdown,
    defaultProps: {
      title: "Alerts",
      iconName: "bell",
      showAllLink: '/alerts',
      hideOnly: ['missing_tags']
    }
  }
];

const MainPageHeader = React.memo(({ ...rest }) => {
  const { state: auth } = useAuth();
  const missingTagsIsVisible = useFeatureToggleItem(`${featureToggles.NOTIFICATIONS}.missing_tags`)?.visible;
  const chatIsVisible = useFeatureToggleItem(featureToggles.CHAT)?.visible;

  return (
    <StyledPageHeader
      {...rest}
      extra={auth.currentUser.role !== userRole.AGENCY ? (
        <Space style={{ zIndex: 1500 }}>
          {
            mainPageHeaderActions.map(action => {
              switch (action.name) {
                case 'chat':
                  if (chatIsVisible === false) {
                    return null;
                  }
                  break;

                case 'notifications-untagged':
                  if (missingTagsIsVisible === false) {
                    return null;
                  }
                  break;

                default:
                /* make eslint happy :) */
              }

              const { component: ActionComponent, defaultProps = {} } = action;

              return <ActionComponent key={action.name} {...defaultProps} />
            })
          }
        </Space>
      ) : null}
    />
  );
});

export default MainPageHeader;
